import type { GetTweetById200ReferencedTweetTweetAuthorBasicInfo } from './getTweetById200ReferencedTweetTweetAuthorBasicInfo';
import type { GetTweetById200ReferencedTweetTweetAuthorSocial } from './getTweetById200ReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type GetTweetById200ReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: GetTweetById200ReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetTweetById200ReferencedTweetTweetAuthorSocial;
};
